import axios from 'axios';
import instance from './helpers/instance';

const locationsService = {
    forwardGeocode,
    reverseGeocode,
    autocompleteSuggestions,
    fetchRegions,
    addUserLocation,
    confirmWhitelabelUserLocation,
    updateWhitelabelBookingLocation,
    setWhitelabelUserLocationById,
    getUserLocations,
    addWhitelabelBookingLocation,
    addClientLocation,
    mapLocationToOperationAreaId
}

const hereAPICode = process.env.REACT_APP_HERE_MAPS_API_CODE;
const hereAPIId = process.env.REACT_APP_HERE_MAPS_API_ID;
const hereAPIKey = process.env.REACT_APP_HERE_MAPS_API_KEY;

const API_URL = process.env.REACT_APP_WEB_ADMIN_URL;


function onSuccess(result) {
    return result;
}

function onError(error) {
    console.log(error);
    return null;
}

async function confirmWhitelabelUserLocation(bookingId) {
    const result = await axios.post(`${API_URL}/api/1/whitelabel/bookings/locations/confirm`, { request_id: bookingId })
    return result?.data
}

async function updateWhitelabelBookingLocation(bookingId, location) {
    const result = await axios.post(`${API_URL}/api/1/whitelabel/bookings/locations/update`, { ...location, request_id: bookingId })
    return result?.data
}

async function addWhitelabelBookingLocation(bookingId, location) {
    const result = await axios.post(`${API_URL}/api/1/whitelabel/bookings/locations/add`, { ...location, request_id: bookingId })
    return result?.data
}

async function addClientLocation(clientId, params) {
    const result = await axios.post(`${API_URL}/api/1/clients/${clientId}/locations`, params)
    return result?.data
}

async function forwardGeocode(query, latitude, longitude) {
    var params = {
        query: query,
        latitude,
        longitude,
        source: 'WHITE_LABEL_CLIENT',
        device_type: 'WEB'
    };
    
    const user = JSON.parse(localStorage.getItem("user"))
    const paramStr = new URLSearchParams(params).toString();
    const request = {
        method: "GET",
        headers: {
            "X-Auth-Token": user?.token ?? "",
        },
        cache: "force-cache",
    };
    const result = await fetch(`${`${API_URL}/api/1/geocoding/forward`}?${paramStr}`, request);
    
    return await result?.json();
        
}
function reverseGeocode({ latitude, longitude }) {
    var params = {
        latitude,
        longitude,
        apiKey: process.env.REACT_APP_HERE_MAPS_API_KEY,
    };

    return axios.get(`${API_URL}/api/1/geocoding/reverse`, { params: params })
        .then(response => {
            return response.data;
        })
}

async function mapLocationToOperationAreaId({
    latitude, longitude
}) {
    const result = await axios.get(`${API_URL}/api/1/operation_areas/current`, { params: { latitude, longitude } })
    return result?.data?.area?.id
}

function autocompleteSuggestions(query) {
    var params = {
        app_id: hereAPIId,
        app_code: hereAPICode,
        query: query
    }

    return axios.get(`https://autocomplete.geocoder.api.here.com/6.2/suggest.json`, { params: params }).then(
        response => {
            return response.data;
        }
    )
}

async function getUserLocations(clientId, {confirmedOnly = true}) {
    const result = await axios.get(`${API_URL}/api/1/clients/${clientId}/locations`)
    let list = []
    if (confirmedOnly) {
        list = result?.data?.list?.filter(location => location?.is_confirmed)
    } else {
        list = result?.data?.list
    }
    return list?.sort((a, b) => b?.is_confirmed - a?.is_confirmed)
}

async function addUserLocation(clientId, location) {
    const result = await axios.post(`${API_URL}/api/1/clients/${clientId}/locations`, location)
    return result?.data
}

async function setWhitelabelUserLocationById(requestId, locationId) {
    const result = await axios.post(`${API_URL}/api/1/whitelabel/bookings/locations/set`, {location: locationId, request_id: requestId})
    return result?.data
}
async function fetchRegions() {
    const result = await instance.get(`${API_URL}/api/1/corporate/regions`)
    return result?.data
}


export default locationsService;